export default "__VITE_ASSET__w38jPqTr__"